import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { CustomerVenue } from "src/app/shared/models/Customer/CustomerVenue.entity";

@Component({
	selector: "app-about-me-venue-detail",
	templateUrl: "./about-me-venue-detail.component.html",
	styleUrls: ["../../../../customer.scss"],
})
export class AboutMeVenueDetailComponent implements OnInit {
	@Input() venueKey: number;

	venue: CustomerVenue;

	constructor(public app: AppService, public customerService: CustomerService) {}

	ngOnInit(): void {
		this.venue = this.customerService.publicCustomer.value.venues.find((venue) => venue.venueKey === this.venueKey);
	}
}
